import React from "react";
import {Toggle} from "@fluentui/react";

import type IsaacToggleButtonProps from "./IsaacToggleButtonProps";

const IsaacToggleButton: React.FunctionComponent<IsaacToggleButtonProps> = ({onChange, checked, disabled}) => (
  <Toggle
    checked={checked}
    onText="On"
    offText="Off"
    onChange={(e: React.MouseEvent<HTMLElement>, toggled?: boolean) => {
      onChange(toggled);
    }}
    disabled={disabled ?? false}
  />
);

export default IsaacToggleButton;
